export const ORDERED_ADDR_KEYS = ['street', 'apt', 'city', 'state', 'zip'];
export const FULLNAME = ['firstName', 'middleName', 'lastName'];
